import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../components/FontAwesomeIcons";
import {getReservationStatusBadgeClassName, getReservationStatusLabel} from "./UserEventReservationStatus";

export class UserEventReservationItem extends React.Component {
    constructor(props) {
        super(props);
        this.defaultValue = "-";
    }

    getAttendanceBadge = _ => {
        const reservation = this.props.reservation || {};
        return {
            label: getReservationStatusLabel(reservation.status),
            className: getReservationStatusBadgeClassName(reservation.status),
        };
    }

    handleClick = _ => this.props.onClick(this.props.reservation)

    renderWarning = (icon, label) => (
        <div className={"alert alert-warning py-1 px-2 mb-1 small"}>
            <FaSolidIcon name={icon} className={"mr-1"}/>
            {label}
        </div>
    )

    render() {
        const reservation = this.props.reservation || {};
        const badge = this.getAttendanceBadge();
        const fullName = reservation.full_name || [reservation.name, reservation.surname].filter(Boolean).join(" ") || this.defaultValue;
        return (
            <li className={"list-group-item border-0 shadow-sm"} onClick={this.handleClick}>
                <div className={"d-flex justify-content-between align-items-center"}>
                    <div>
                        <div className={"d-flex align-items-center"}>
                            <span className={badge.className}>{badge.label}</span>
                            <div className={"ml-2 small text-muted"}>
                                <FaSolidIcon name={"users"} className={"mr-1"}/>
                                {reservation.participants_number || 0} partecipanti
                            </div>
                        </div>
                        <div className={"font-weight-bold"}>{fullName}</div>
                        <div className={"small text-muted"}>{reservation.email || "Email non disponibile"}</div>
                        <div className={"d-flex mt-2"}>
                            {
                                reservation.notes &&
                                <small className={"alert alert-warning small m-0 mr-1 p-1"}>
                                    <FaSolidIcon name={"note-sticky"}/> Note
                                </small>
                            }
                            {
                                reservation.intolerances &&
                                <small className={"alert alert-danger small m-0 mr-1 p-1"}>
                                    <FaSolidIcon name={"exclamation-triangle"}/> Intolleranze
                                </small>
                            }
                        </div>
                    </div>
                    <div className={"text-muted"}>
                        <FaSolidIcon name={"chevron-right"}/>
                    </div>
                </div>
            </li>
        );
    }
}

UserEventReservationItem.propTypes = {
    reservation: PropTypes.object,
    onClick: PropTypes.func,
};
